// import '@babel/polyfill'

import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false


import VueCollide from './plugins/VueCollide'
import VueScrollTo from 'vue-scrollto'
import VueHead from 'vue-head'

Vue.use(VueHead)
Vue.use(VueCollide)

Vue.use(VueScrollTo, {
	container: 'body',
	duration: 400,
	easing: 'ease',
	offset: 0,
	cancelable: false,
	onStart: false,
	onDone: false,
	onCancel: false,
	x: false,
	y: true
})


Vue.use(Vuex)

let store = new Vuex.Store({
	state: {
		device: window.innerWidth >= 960 ? 'desktop' : 'mobile',
	},
	mutations: {
		setDevice(state, data) {
			state.device = data
		},
	},
	strict: false,
})

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')